import { Modal } from '../../customComponents/Modal'

interface Props {
  onClose: () => void
  onConfirm: () => void
}

export const ClearTrackingModal = (props: Props): JSX.Element => {
  return <>
    <Modal
      open={true}
      onConfirm={props.onConfirm}
      onClose={props.onClose}
      title='Are you sure?'
      cancelButtonText='No, Cancel'
      confirmButtonText='Yes, Delete'
      data-testid='clearTrackingModal'
      bodyContent={'Are you sure you want to clear tracked information?'}
      maxWidth='xs'
    />
  </>
}
